import { render } from "./PassReservationCard.vue?vue&type=template&id=8241726c&scoped=true"
import script from "./PassReservationCard.vue?vue&type=script&lang=js"
export * from "./PassReservationCard.vue?vue&type=script&lang=js"

import "./PassReservationCard.vue?vue&type=style&index=0&id=8241726c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8241726c"]])

export default __exports__